/**
 * Построение URL для отправки в RUM счетчик.
 *
 * @kind helper
 * @return Правильный URL для отправки в RUM.
 */
export function buildRumUrl() {
    const { pathname, search, hash } = window.location;

    return [pathname, search, hash].join('');
}
